import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";
import deleteAccount from "./delete-account.json";

const account = {
  ...getI18nJsonProp(base, "account"),
  ...getI18nJsonProp(deleteAccount, "account"),
};

export default account;
